import { Site } from "../models/site";
import axiosConfig from "./axiosConfig";

interface SiteCopyBody {
  newName?: string;
  copyToOrgId?: string;
  [key: string]: any;
}

const postSiteCopy = async (
  authToken: string,
  siteId: string,
  copyBody: SiteCopyBody
): Promise<{ site_id: string } & Partial<Site>> => {
  const { data } = await axiosConfig.post(`/site/${siteId}/copy`, copyBody, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postSiteCopy;
